'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var SecondaryButton = require('../SecondaryButton/SecondaryButton.js');
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));
var ConfirmationBadge = require('../../statuses/ConfirmationBadge/ConfirmationBadge.js');
var styledComponents = require('./styled-components.js');

var ButtonAndStatus = function (props) {
    var actionHandler = props.actionHandler, buttonText = props.buttonText, _a = props.loading, loading = _a === void 0 ? false : _a, showStatus = props.showStatus, _b = props.statusText, statusText = _b === void 0 ? '' : _b, _c = props["data-testid"], dataTestId = _c === void 0 ? 'status-button' : _c;
    if (loading) {
        return (React__default.createElement(styledComponents, null,
            React__default.createElement(CircularProgress, { style: { height: '1rem', width: '1rem' }, "data-testid": 'spinner' })));
    }
    return (React__default.createElement(styledComponents, null, showStatus ? (React__default.createElement(ConfirmationBadge, { label: statusText })) : (React__default.createElement(SecondaryButton, { onClick: actionHandler, title: buttonText, "data-testid": dataTestId }))));
};

module.exports = ButtonAndStatus;
